import { baseApi, PaginatedResponse } from 'sama-shared';
import type { GetInvoicesParams } from '../../types/api';
import type { AdminInvoice } from './types/invoice';

export const invoiceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInvoices: builder.query<PaginatedResponse<AdminInvoice>, GetInvoicesParams>({
      query: (params) => ({
        url: '/admin/invoice',
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Invoice' as const, id })),
              { type: 'Invoice', id: 'LIST' },
            ]
          : [{ type: 'Invoice', id: 'LIST' }],
    }),

    getInvoiceById: builder.query<AdminInvoice, string>({
      query: (id) => ({
        url: `/admin/invoice/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Invoice' as const, id }],
    }),
  }),

  overrideExisting: false,
});

export const { useGetInvoicesQuery, useGetInvoiceByIdQuery } = invoiceApi;
